import {
  createCover,
  createCompany,
  createCorporateUser,
  editCover,
  editCompany,
  editCorporateUser,
  getOpenCovers,
  getCompanies,
  getCorporateUsers
} from '../utils/apiService';

export const CREATE_COVER = 'covers/CREATE_COVER';
export const CREATE_COVER_PENDING = 'covers/CREATE_COVER_PENDING';
export const CREATE_COVER_FULFILLED = 'covers/CREATE_COVER_FULFILLED';
export const CREATE_COVER_REJECTED = 'covers/CREATE_COVER_REJECTED';

export const CREATE_COMPANY = 'covers/CREATE_COMPANY';
export const CREATE_COMPANY_PENDING = 'covers/CREATE_COMPANY_PENDING';
export const CREATE_COMPANY_FULFILLED = 'covers/CREATE_COMPANY_FULFILLED';
export const CREATE_COMPANY_REJECTED = 'covers/CREATE_COMPANY_REJECTED';

export const CREATE_CORPORATE_USER = 'covers/CREATE_CORPORATE_USER';
export const CREATE_CORPORATE_USER_PENDING =
  'covers/CREATE_CORPORATE_USER_PENDING';
export const CREATE_CORPORATE_USER_FULFILLED =
  'covers/CREATE_CORPORATE_USER_FULFILLED';
export const CREATE_CORPORATE_USER_REJECTED =
  'covers/CREATE_CORPORATE_USER_REJECTED';

export const LIST_COVERS = 'covers/LIST_COVERS';
export const LIST_COVERS_PENDING = 'covers/LIST_COVERS_PENDING';
export const LIST_COVERS_REJECTED = 'covers/LIST_COVERS_REJECTED';
export const LIST_COVERS_FULFILLED = 'covers/LIST_COVERS_FULFILLED';

export const LIST_COMPANIES = 'covers/LIST_COMPANIES';
export const LIST_COMPANIES_PENDING = 'covers/LIST_COMPANIES_PENDING';
export const LIST_COMPANIES_REJECTED = 'covers/LIST_COMPANIES_REJECTED';
export const LIST_COMPANIES_FULFILLED = 'covers/LIST_COMPANIES_FULFILLED';

export const LIST_CORPORATES = 'covers/LIST_CORPORATES';
export const LIST_CORPORATES_PENDING = 'covers/LIST_CORPORATES_PENDING';
export const LIST_CORPORATES_REJECTED = 'covers/LIST_CORPORATES_REJECTED';
export const LIST_CORPORATES_FULFILLED = 'covers/LIST_CORPORATES_FULFILLED';

export const saveCover = cover => {
  const payload = createCover(cover);
  return {
    type: CREATE_COVER,
    payload
  };
};

export const saveCompany = company => {
  const payload = createCompany(company);
  return {
    type: CREATE_COMPANY,
    payload
  };
};

export const saveCorporateUser = user => {
  const payload = createCorporateUser(user);
  return {
    type: CREATE_CORPORATE_USER,
    payload
  };
};

export const updateCover = cover => {
  const payload = editCover(cover);
  return {
    type: CREATE_COVER,
    payload
  };
};

export const updateCompany = company => {
  const payload = editCompany(company);
  return {
    type: CREATE_COMPANY,
    payload
  };
};

export const updateCorporateUser = corporate => {
  const payload = editCorporateUser(corporate);
  return {
    type: CREATE_CORPORATE_USER,
    payload
  };
};

export const listCovers = filter => {
  const payload = getOpenCovers(filter);
  return {
    type: LIST_COVERS,
    payload
  };
};

export const listCompanies = filter => {
  const payload = getCompanies(filter);
  return {
    type: LIST_COMPANIES,
    payload
  };
};

export const listCorporates = () => {
  const payload = getCorporateUsers();
  return {
    type: LIST_CORPORATES,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/openCovers.js